import {
  USERS_TAB,
  ROLES_TAB,
  PRODUCTS_TAB,
  HEALTH_STATUS_TAB,
  RETAILER_REPORTS_TAB,
} from "../../framework/tab/tabUtilsConstants";
import icons from "./../../assets/images/spotlight";
export const allMenus = [
  {
    main_menu: "roles_management",
    label: "Roles Management",
    menu_icon: icons.salesIcon,
    isAccessible: true,
    menu_icon_active: icons.salesActiveIcon,
    sub_menus: [
      {
        sub_menu: "Users",
        isAccessible: true,
        component: USERS_TAB,
        // menu_icon_active: icons.purchaseActiveIcon, //to overide main menu icon
      },
      {
        sub_menu: "Roles",
        isAccessible: true,
        component: ROLES_TAB,
        // menu_icon_active: icons.purchaseActiveIcon, //to overide main menu icon
      },
      // {
      //   sub_menu: "Retailer",
      //   isAccessible: true,
      //   component: RETAILER_REPORTS_TAB,
      //   // menu_icon_active: icons.purchaseActiveIcon, //to overide main menu icon
      // }, # Uncomment if DMart ask for it.
    ],
  },
  {
    main_menu: "master",
    label: "Master",
    menu_icon: icons.salesIcon,
    isAccessible: false,
    menu_icon_active: icons.salesActiveIcon,
    sub_menus: [
      {
        sub_menu: "Product (Articles)",
        isAccessible: true,
        component: PRODUCTS_TAB,
        // menu_icon_active: icons.purchaseActiveIcon, //to overide main menu icon
      },
    ],
  },
  {
    main_menu: "Miscellaneous",
    label: "Miscellaneous",
    menu_icon: icons.doctorIcon,
    isAccessible: true,
    menu_icon_active: icons.doctorActiveIcon,
    sub_menus: [
      {
        sub_menu: "Server Health",
        isAccessible: true,
        component: HEALTH_STATUS_TAB,
      },
    ],
  },
];
